import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useAlgNode from '../_ALG/useAlgNode.jsx'
import meta from './metaBdalg.mjs'
import PropertiesPane from './PropertiesPaneBdalg.jsx'
import PropertiesPaneBatch from './PropertiesPaneBatchBdalg.jsx'

export default () => {
    const AlgNode = useAlgNode()

    return extendNode(AlgNode, {
        ...meta,
        PropertiesPane,
        PropertiesPaneBatch,

        _pushDataSlots: {
            fcCode: '',
            sfCodes: [],
        },

        async _atOwnerPush(map, node, event) {
            const d = await this._getPushData(map, node)
            event.detail.algList.push(d)
        },

        _getCategories(map, node) {
            return [
                'ALG_RULE',
                'ALG_ALG',
                'ALG_API',
            ]
        },

        _getShape(map, node) {
            return 'HorizontalHexagon'
        },
    })
}
